// extracted by mini-css-extract-plugin
export default {"Blink":"DotDotDot_Blink__0MIce","blink":"DotDotDot_blink__TfEcd"};